import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/build/incl/layouts/default.vue").then(m => m.default || m)),
  screening: defineAsyncComponent(() => import("/build/incl/layouts/screening.vue").then(m => m.default || m)),
  selection: defineAsyncComponent(() => import("/build/incl/layouts/selection.vue").then(m => m.default || m)),
  tablet: defineAsyncComponent(() => import("/build/incl/layouts/tablet.vue").then(m => m.default || m))
}